import type { SVGProps } from 'react';

export function WizardIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.546 17.4a.5.5 0 0 1-.462-.69l2.93-7.117a7.2 7.2 0 0 1 3.27-3.612l5.509-2.936a.6.6 0 0 1 .862.683l-1.395 5.34q-.06.23-.06.472c0 .236.045.473.135.694l2.59 6.48a.5.5 0 0 1-.463.686h-6.334a.5.5 0 0 1-.475-.658l.144-.433a.5.5 0 0 1 .316-.316l1.278-.427a.602.602 0 0 0 0-1.14L12.113 14a.5.5 0 0 1-.316-.316l-.427-1.278a.603.603 0 0 0-1.14.004l-.427 1.278a.5.5 0 0 1-.316.316l-1.278.427a.602.602 0 0 0 0 1.14l1.278.427a.5.5 0 0 1 .316.316l.144.432a.5.5 0 0 1-.475.658zm7.339-9.694A.3.3 0 0 0 12.6 7.5a.3.3 0 0 0-.285.206l-.172.52a.5.5 0 0 1-.317.317l-.52.172A.3.3 0 0 0 11.1 9c0 .131.082.244.206.285l.52.172a.5.5 0 0 1 .317.317l.172.52a.3.3 0 0 0 .285.206.3.3 0 0 0 .285-.206l.172-.52a.5.5 0 0 1 .317-.317l.52-.172A.3.3 0 0 0 14.1 9a.3.3 0 0 0-.206-.285l-.52-.172a.5.5 0 0 1-.317-.317zM3.6 19.2h16.8c.664 0 1.2.536 1.2 1.2s-.536 1.2-1.2 1.2H3.6c-.664 0-1.2-.536-1.2-1.2s.536-1.2 1.2-1.2" />
    </svg>
  );
}
